import React from "react";
import EditRoleAssignment from "../EditRoleAssignment";
import useSelector from "../../../store/useSelector";
import { useParams } from "react-router-dom";
import { Routes } from "components/routing/Routing";

interface IViewSystemAccessRequestRoleAssignment
{

}

const ViewSystemAccessRequestRoleAssignment: React.FC<IViewSystemAccessRequestRoleAssignment> =
  (props) => {
    const {
      userManagement: {
        bulkEditUserData: {
          isEditRoleAssignment
        }
      }
    } = useSelector(store => store);

    const {id: newId} = useParams();
    const urlId : string = newId!;
    const pageTitle = isEditRoleAssignment ? "Edit access detail" : "Enter access detail";

    return (
      <EditRoleAssignment
        title={pageTitle}
        redirectRoute={Routes.ViewSystemAccessRequest.replace(":id", urlId)}
        onInvalidSelectedUserRoute={Routes.ViewSystemAccessRequest}/>
    )
  }
export default ViewSystemAccessRequestRoleAssignment;